export default __webpack_public_path__ + "static/media/tolulope.c16e1af3.webp";